<section class="breadcrumbs_common bg_img pos_relative">
    <div class="overlay-innerpage"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumbs_content">
                    <h2 class="text-white">POs & COs</h2>
                    <ul class="breadcrumb">
                        <li>
                            <a routerLink="/">Home</a>
                        </li>/
                        <li class="active">
                            <a href="javascript:void(0);">POs & COs</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="horizontal--tab ptb--100">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="po-tab" data-bs-toggle="tab" data-bs-target="#po"
                            type="button" role="tab" aria-controls="po" aria-selected="true">PO</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="bsc-tab" data-bs-toggle="tab" data-bs-target="#bsc" type="button"
                            role="tab" aria-controls="bsc" aria-selected="false">BSc</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="bcom-tab" data-bs-toggle="tab" data-bs-target="#bcom" type="button"
                            role="tab" aria-controls="bcom" aria-selected="false">BCom</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="bba-tab" data-bs-toggle="tab" data-bs-target="#bba" type="button"
                            role="tab" aria-controls="bba" aria-selected="false">BBA</button>
                    </li>
                </ul>
            </div>
            <div class="col-md-12">
                <div class="tab-content px-3 py-3" id="myTabContent">
                    <div class="tab-pane fade show active" id="po" role="tabpanel" aria-labelledby="po-tab">
                        <h4 class="purple-color fw-bold my-2">PROGRAM OUTCOMES (PO)</h4>
                        <div class="table-responsive pt-3">
                            <table class="table table-bordered table-hover table-striped">
                                <tbody>
                                    <tr class="table-class">
                                        <td>PO1</td>
                                        <td><b>Knowledge:</b> To enhance the knowledge of Business and Commerce</td>
                                    </tr>
                                    <tr>
                                        <td>PO2</td>
                                        <td><b>Ability:</b> ability to use current techniques, skills, and modern tools
                                            necessary for computing practice.</td>
                                    </tr>
                                    <tr>
                                        <td>PO3</td>
                                        <td><b>Understand:</b> the nature and basic concepts of Indian and world
                                            economy, cost benefits analysis, mathematical tools, science and technology
                                            related to electronics and computer field.</td>
                                    </tr>
                                    <tr>
                                        <td>PO4</td>
                                        <td><b>Critical Thinking:</b> Take informed actions after identifying the
                                            assumptions that frame our thinking and actions, checking out the degree to
                                            which these assumptions are accurate and valid, and looking at our ideas and
                                            decisions (intellectual,
                                            organizational, and personal) from different perspectives</td>
                                    </tr>
                                    <tr>
                                        <td>PO5</td>
                                        <td><b>Effective Communication:</b> Speak, read, write and listen clearly in
                                            person and through electronic media in English and in one Indian language,
                                            and make meaning of the world by connecting people, ideas, books, media and
                                            technology.</td>
                                    </tr>
                                    <tr>
                                        <td>PO6</td>
                                        <td><b>Social Interaction:</b> Elicit views of others, mediate disagreements and
                                            help reach conclusions in group settings.</td>
                                    </tr>
                                    <tr>
                                        <td>PO7</td>
                                        <td><b>Effective Citizenship:</b> Demonstrate empathetic social concern and
                                            equity centred national development, and the ability to act with an informed
                                            awareness of issues and participate in civic life through volunteering</td>
                                    </tr>
                                    <tr>
                                        <td>PO8</td>
                                        <td><b>Ethics:</b> Recognize different value systems including your own,
                                            understand the moral dimensions of your decisions, and accept responsibility
                                            for them.</td>
                                    </tr>
                                    <tr>
                                        <td>PO9</td>
                                        <td><b>Environment and Sustainability:</b> Understand the issues of
                                            environmental contexts and sustainable development.</td>
                                    </tr>
                                    <tr>
                                        <td>PO10</td>
                                        <td><b>Self-directed and Life-long Learning:</b> Acquire the ability to engage
                                            in independent and life-long learning in the broadest context
                                            socio-technological changes.</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="bsc" role="tabpanel" aria-labelledby="bsc-tab">
                        <h4 class="purple-color fw-bold my-2">BACHELOR OF SCIENCE (COMPUTER SCIENCE) (B.Sc (CS)) PROGRAM
                            SPECIFIC OUTCOME(PSO’s)</h4>
                        <div class="department-table pt-3 table-responsive">
                            <table class="table table-bordered table-hover table-striped">
                                <tbody>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>Programme Outcomes Upon completion of the BSc(CS) Degree Programme, the
                                            graduate will be able to</td>
                                    </tr>
                                    <tr>
                                        <td>PO1</td>
                                        <td>Critical Thinking: This outcome emphasizes the development of analytical and
                                            evaluative skills. It encourages students to think logically, assess
                                            situations, solve problems, and make decisions based on evidence and
                                            reasoning.</td>
                                    </tr>
                                    <tr>
                                        <td>PO2</td>
                                        <td>Effective Communication: This outcome focuses on the ability to express
                                            ideas clearly and coherently, both in written and oral forms. It includes
                                            the ability to listen, understand, and respond appropriately in various
                                            contexts and with diverse
                                            audiences.</td>
                                    </tr>
                                    <tr>
                                        <td>PO3</td>
                                        <td>Social Interaction: This outcome encourages students to develop
                                            interpersonal skills. It involves understanding and respecting cultural
                                            differences, working collaboratively in teams, and engaging in constructive
                                            interactions with others.</td>
                                    </tr>
                                    <tr>
                                        <td>PO4</td>
                                        <td>Effective Citizenship: This refers to the responsibility of individuals to
                                            actively engage in their communities and society at large. It includes being
                                            informed about social issues, understanding political processes, and
                                            contributing positively
                                            to the collective well-being of society.</td>
                                    </tr>
                                    <tr>
                                        <td>PO5</td>
                                        <td>Ethics: This outcome stresses the importance of ethical behaviour in both
                                            personal and professional contexts. Students are encouraged to make
                                            decisions and take actions that align with moral principles, social justice,
                                            and fairness.</td>
                                    </tr>
                                    <tr>
                                        <td>PO6</td>
                                        <td>Environment and Sustainability: This program outcome highlights the
                                            importance of understanding environmental issues and the need for
                                            sustainable practices. It encourages students to consider the environmental
                                            impact of their decisions and
                                            to contribute to sustainable development.</td>
                                    </tr>
                                    <tr>
                                        <td>PO7</td>
                                        <td>Self-directed and Life-long Learning: This outcome stresses the ability to
                                            independently seek knowledge and skills throughout one's life. It encourages
                                            students to take responsibility for their own learning, adapt to changing
                                            circumstances,
                                            and continue to grow professionally and personally.</td>
                                    </tr>
                                    <tr>
                                        <td> </td>
                                        <td> Program Specific Outcomes (PSO's)</td>
                                    </tr>
                                    <tr>
                                        <td>PSO1</td>
                                        <td>Problem-Solving Skills in Computer Science: Graduates will be able to apply
                                            computational and algorithmic principles to solve real-world problems. This
                                            includes the design, analysis, and implementation of software solutions to
                                            address various
                                            challenges in different domains.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO2</td>
                                        <td>Proficiency in Programming Languages and Software Tools: Graduates will have
                                            a strong foundation in programming languages such as Python, Java, C++,
                                            etc., and will be proficient in using development tools and platforms for
                                            software design,
                                            testing, and deployment.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO3</td>
                                        <td>Understanding of Computer Networks and Security: Graduates will possess
                                            knowledge of computer networks, including their protocols, architecture, and
                                            security measures. They will be equipped to design secure systems and ensure
                                            the safety of
                                            data in a connected world.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO4</td>
                                        <td>Awareness of Emerging Technologies: Graduates will be aware of the latest
                                            trends in technology, including artificial intelligence, machine learning,
                                            data science, block chain, and cloud computing. They will be prepared to
                                            adapt and implement
                                            these technologies in relevant fields.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO5</td>
                                        <td>Software Project Management and Teamwork: Graduates will be able to work
                                            effectively in teams, manage software development projects, and apply
                                            project management methodologies to deliver high-quality products within
                                            time and budget constraints.
                                        </td>
                                    </tr>
                                </tbody>
                                <!-- <tbody>
                                <tr class="table-class">
                                    <td>PSO1</td>
                                    <td>Demonstrate mastery of Computer Science in the following core knowledge areas:
                                    <br>a) Data Structures and Programming Languages
                                    <br>b) Databases, Software Engineering and Development
                                    <br>c) Computer Hardware and Architecture
                                    </td>
                                </tr>
                                <tr>
                                    <td>PSO2</td>
                                    <td>Apply problem-solving skills and the knowledge of computer Science, manipulation techniques and embedded developments skills to solve real world problems.</td>
                                </tr>
                                <tr>
                                    <td>PSO3</td>
                                    <td>Apply computer science theory and software development</td>
                                </tr>
                                <tr>
                                    <td>PSO4</td>
                                    <td>Recognize the societal and global context of their work and understand professional and Ethical responsibilities.</td>
                                </tr>
                                </tbody> -->
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="bcom" role="tabpanel" aria-labelledby="bcom-tab">
                        <h4 class="purple-color fw-bold my-2">BACHELOR OF COMMERCE(B.Com) PROGRAM SPECIFIC OUTCOMES
                            (PSO’s)</h4>
                        <div class="department-table pt-3 table-responsive">
                            <table class="table table-bordered table-hover table-striped">
                                <tbody>
                                    <tr>
                                        <td> </td>
                                        <td>Programme Outcomes Upon completion of the B.Com Degree Programme, the
                                            graduate will be able to</td>
                                    </tr>
                                    <tr>
                                        <td>PO1</td>
                                        <td>Critical Thinking: This outcome emphasizes the development of analytical and
                                            evaluative skills. It encourages students to think logically, assess
                                            situations, solve problems, and make decisions based on evidence and
                                            reasoning.</td>
                                    </tr>
                                    <tr>
                                        <td>PO2</td>
                                        <td>Effective Communication: This outcome focuses on the ability to express
                                            ideas clearly and coherently, both in written and oral forms. It includes
                                            the ability to listen, understand, and respond appropriately in various
                                            contexts and with diverse
                                            audiences.</td>
                                    </tr>
                                    <tr>
                                        <td>PO3</td>
                                        <td>Social Interaction: This outcome encourages students to develop
                                            interpersonal skills. It involves understanding and respecting cultural
                                            differences, working collaboratively in teams, and engaging in constructive
                                            interactions with others.</td>
                                    </tr>
                                    <tr>
                                        <td>PO4</td>
                                        <td>Effective Citizenship: This refers to the responsibility of individuals to
                                            actively engage in their communities and society at large. It includes being
                                            informed about social issues, understanding political processes, and
                                            contributing positively
                                            to the collective well-being of society.</td>
                                    </tr>
                                    <tr>
                                        <td>PO5</td>
                                        <td>Ethics: This outcome stresses the importance of ethical behavior in both
                                            personal and professional contexts. Students are encouraged to make
                                            decisions and take actions that align with moral principles, social justice,
                                            and fairness.</td>
                                    </tr>
                                    <tr>
                                        <td>PO6</td>
                                        <td>Environment and Sustainability: This program outcome highlights the
                                            importance of understanding environmental issues and the need for
                                            sustainable practices. It encourages students to consider the environmental
                                            impact of their decisions and
                                            to contribute to sustainable development.</td>
                                    </tr>
                                    <tr>
                                        <td>PO7</td>
                                        <td>Self-directed and Life-long Learning: This outcome stresses the ability to
                                            independently seek knowledge and skills throughout one's life. It encourages
                                            students to take responsibility for their own learning, adapt to changing
                                            circumstances,
                                            and continue to grow professionally and personally.</td>
                                    </tr>
                                    <tr>
                                        <td> </td>
                                        <td> Program Specific Outcomes (PSO's)</td>
                                    </tr>
                                    <tr>
                                        <td>PSO1</td>
                                        <td>Financial Management and Accounting Skills: Students will demonstrate
                                            proficiency in accounting principles, financial reporting, and management
                                            accounting. They will be able to analyse financial statements, manage
                                            budgets, and use accounting
                                            software to support business decision-making.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO2</td>
                                        <td>Business Law and Taxation Knowledge: Students will gain an understanding of
                                            key business laws, including contract law, company law, and taxation
                                            systems. They will be able to apply this knowledge to practical business
                                            scenarios, ensuring legal
                                            compliance and optimizing tax planning.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO3</td>
                                        <td>Economics and Business Environment Awareness: Graduates will understand
                                            economic concepts and their application to the business world. They will be
                                            able to analyse market trends, government policies, and global economic
                                            developments to make
                                            informed business decisions.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO4</td>
                                        <td>Ethical and Professional Responsibility: Students will demonstrate awareness
                                            of ethical issues in business and finance. They will be prepared to make
                                            decisions that uphold integrity, transparency, and social responsibility in
                                            their professional
                                            lives.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO5</td>
                                        <td>IT and Digital Literacy: Graduates will be proficient in using information
                                            technology, including accounting software, spread sheets, and enterprise
                                            resource planning (ERP) tools, to support business operations and
                                            decision-making in a digital
                                            business environment.</td>
                                    </tr>
                                </tbody>
                                <!-- <tbody>
                                <tr class="table-class">
                                    <td>PSO1</td>
                                    <td>Students will able to develop their creative knowledge to solve various problems in the organization.</td>
                                </tr>
                                <tr>
                                    <td>PSO2</td>
                                    <td>Students will able to evaluate national and international issue and discussion on economic, commercial and business related topics.</td>
                                </tr>
                                <tr>
                                    <td>PSO3</td>
                                    <td>Students will learn relevant Advanced accounting career skills, applying both quantitative and qualitative knowledge for their future careers in accounting/ taxation/ finance businesses.</td>
                                </tr>
                                </tbody> -->
                            </table>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="bba" role="tabpanel" aria-labelledby="bba-tab">
                        <h4 class="purple-color fw-bold my-2">BACHELOR OF BUSINESS ADMINISTRATION(B.B.A) PROGRAM
                            SPECIFIC OUTCOMES (PSO’s)</h4>
                        <div class="department-table pt-3 table-responsive">
                            <table class="table table-bordered table-hover table-striped">
                                <tbody>
                                    <tr>
                                        <td> </td>
                                        <td>Programme Outcomes Upon completion of the B.Com Degree Programme, the
                                            graduate will be able to</td>
                                    </tr>
                                    <tr>
                                        <td>PO1</td>
                                        <td>Critical Thinking: This outcome emphasizes the development of analytical and
                                            evaluative skills. It encourages students to think logically, assess
                                            situations, solve problems, and make decisions based on evidence and
                                            reasoning.</td>
                                    </tr>
                                    <tr>
                                        <td>PO2</td>
                                        <td>Effective Communication: This outcome focuses on the ability to express
                                            ideas clearly and coherently, both in written and oral forms. It includes
                                            the ability to listen, understand, and respond appropriately in various
                                            contexts and with diverse
                                            audiences.</td>
                                    </tr>
                                    <tr>
                                        <td>PO3</td>
                                        <td>Social Interaction: This outcome encourages students to develop
                                            interpersonal skills. It involves understanding and respecting cultural
                                            differences, working collaboratively in teams, and engaging in constructive
                                            interactions with others.</td>
                                    </tr>
                                    <tr>
                                        <td>PO4</td>
                                        <td>Effective Citizenship: This refers to the responsibility of individuals to
                                            actively engage in their communities and society at large. It includes being
                                            informed about social issues, understanding political processes, and
                                            contributing positively
                                            to the collective well-being of society.</td>
                                    </tr>
                                    <tr>
                                        <td>PO5</td>
                                        <td>Ethics: This outcome stresses the importance of ethical behavior in both
                                            personal and professional contexts. Students are encouraged to make
                                            decisions and take actions that align with moral principles, social justice,
                                            and fairness.</td>
                                    </tr>
                                    <tr>
                                        <td>PO6</td>
                                        <td>Environment and Sustainability: This program outcome highlights the
                                            importance of understanding environmental issues and the need for
                                            sustainable practices. It encourages students to consider the environmental
                                            impact of their decisions and
                                            to contribute to sustainable development.</td>
                                    </tr>
                                    <tr>
                                        <td>PO7</td>
                                        <td>Self-directed and Life-long Learning: This outcome stresses the ability to
                                            independently seek knowledge and skills throughout one's life. It encourages
                                            students to take responsibility for their own learning, adapt to changing
                                            circumstances,
                                            and continue to grow professionally and personally.</td>
                                    </tr>
                                    <tr>
                                        <td> </td>
                                        <td> Program Specific Outcomes (PSO's)</td>
                                    </tr>
                                    <tr>
                                        <td>PSO1</td>
                                        <td>Knowledge of Core Business Concepts and Practices: Students will be able to
                                            demonstrate a deep understanding of core business functions such as
                                            management, marketing, finance, operations, human resources, and
                                            entrepreneurship.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO2</td>
                                        <td>Effective Communication and Interpersonal Skills: Students will be able to
                                            communicate effectively both in writing and verbally, in professional
                                            business contexts.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO3</td>
                                        <td>Leadership and Teamwork: Students will acquire the ability to lead and
                                            manage team's effectively in organizational settings and will be capable of
                                            fostering collaboration, promoting teamwork, and managing group dynamics in
                                            business environments.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO4</td>
                                        <td>Ethical and Social Responsibility: Students will understand the importance
                                            of business ethics, corporate social responsibility (CSR), and sustainable
                                            practices in modern organizations and also can make decisions that are
                                            ethically sound and
                                            socially responsible, contributing to the well-being of society and the
                                            environment.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO5</td>
                                        <td>Technology and Digital Literacy: Students will be familiar with the use of
                                            business software tools, digital platforms, and technology to streamline
                                            business operations and will understand the role of digital transformation
                                            in business and
                                            be able to leverage technology for business growth and innovation.</td>
                                    </tr>
                                </tbody>
                                <!-- <tbody>
                                <tr class="table-class">
                                    <td>PSO1</td>
                                    <td>Recognize the need to adapt business practices to the opportunities and challenges of an evolving global environment.</td>
                                </tr>
                                <tr>
                                    <td>PSO2</td>
                                    <td>Demonstrate ability to recognize and identify ethical conflicts, apply ethical reasoning and assess response options relative to the needs and interests of relevant stakeholders to address issues in a business context.</td>
                                </tr>
                                <tr>
                                    <td>PSO3</td>
                                    <td>Identify, evaluate, analyse, interpret and apply information to address problems and make reasoned decisions in a business context.</td>
                                </tr>
                                <tr>
                                    <td>PSO4</td>
                                    <td>Communicate in a business context in a clear, concise, coherent and professional manner.</td>
                                </tr>
                                <tr>
                                    <td>PSO5</td>
                                    <td>Demonstrate the understanding and ability to apply professional standards, theory, and research to address business problems within specific concentrations.</td>
                                </tr>
                                </tbody> -->
                            </table>
                        </div>


                        <h4 class="purple-color fw-bold my-2">BACHELOR OF BUSINESS ADMINISTRATION (COMPUTER
                            APPLICATION)(B.B.A(CA)) PROGRAM SPECIFIC OUTCOME(PSO’s)</h4>
                        <div class="department-table pt-3 table-responsive">
                            <table class="table table-bordered table-hover table-striped">
                                <tbody>
                                    <tr>
                                        <td> </td>
                                        <td>Programme Outcomes Upon completion of the B.Com Degree Programme, the
                                            graduate will be able to</td>
                                    </tr>
                                    <tr>
                                        <td>PO1</td>
                                        <td>Critical Thinking: This outcome emphasizes the development of analytical and
                                            evaluative skills. It encourages students to think logically, assess
                                            situations, solve problems, and make decisions based on evidence and
                                            reasoning.</td>
                                    </tr>
                                    <tr>
                                        <td>PO2</td>
                                        <td>Effective Communication: This outcome focuses on the ability to express
                                            ideas clearly and coherently, both in written and oral forms. It includes
                                            the ability to listen, understand, and respond appropriately in various
                                            contexts and with diverse
                                            audiences.</td>
                                    </tr>
                                    <tr>
                                        <td>PO3</td>
                                        <td>Social Interaction: This outcome encourages students to develop
                                            interpersonal skills. It involves understanding and respecting cultural
                                            differences, working collaboratively in teams, and engaging in constructive
                                            interactions with others.</td>
                                    </tr>
                                    <tr>
                                        <td>PO4</td>
                                        <td>Effective Citizenship: This refers to the responsibility of individuals to
                                            actively engage in their communities and society at large. It includes being
                                            informed about social issues, understanding political processes, and
                                            contributing positively
                                            to the collective well-being of society.</td>
                                    </tr>
                                    <tr>
                                        <td>PO5</td>
                                        <td>Ethics: This outcome stresses the importance of ethical behavior in both
                                            personal and professional contexts. Students are encouraged to make
                                            decisions and take actions that align with moral principles, social justice,
                                            and fairness.</td>
                                    </tr>
                                    <tr>
                                        <td>PO6</td>
                                        <td>Environment and Sustainability: This program outcome highlights the
                                            importance of understanding environmental issues and the need for
                                            sustainable practices. It encourages students to consider the environmental
                                            impact of their decisions and
                                            to contribute to sustainable development.</td>
                                    </tr>
                                    <tr>
                                        <td>PO7</td>
                                        <td>Self-directed and Life-long Learning: This outcome stresses the ability to
                                            independently seek knowledge and skills throughout one's life. It encourages
                                            students to take responsibility for their own learning, adapt to changing
                                            circumstances,
                                            and continue to grow professionally and personally.</td>
                                    </tr>
                                    <tr>
                                        <td> </td>
                                        <td> Program Specific Outcomes (PSO's)</td>
                                    </tr>
                                    <tr>
                                        <td>PSO1</td>
                                        <td>Understanding of Business and IT Integration: Students will demonstrate a
                                            strong understanding of how business administration principles and
                                            information technology complement each other to enhance organizational
                                            efficiency and performance.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO2</td>
                                        <td>Proficiency in Business Software and IT Tools: Students will be proficient
                                            in using various business software applications (e.g., ERP systems,
                                            accounting software, and business analytics tools) and IT tools to solve
                                            business-related problems.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO3</td>
                                        <td>Database Management and Data Analytics: Students will be capable of managing
                                            and analysing business data using database management systems (DBMS) and
                                            data analytics tools and will interpret data effectively to provide valuable
                                            insights for
                                            strategic decision-making in business settings.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO4</td>
                                        <td>Understanding of Business Ethics and Legal Aspects of IT: Students will
                                            demonstrate an understanding of ethical issues in business and the legal
                                            implications of using information technology in business practices and will
                                            be able to navigate
                                            challenges related to data privacy, intellectual property, and legal
                                            compliance in IT-enabled business processes.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO5</td>
                                        <td>Problem-Solving and Critical Thinking Using Technology: Students will
                                            develop the ability to analyse business challenges and propose
                                            technology-driven solutions, improving operational and organizational
                                            efficiency also able to apply analytical
                                            thinking to solve real-world business problems with the help of information
                                            technology.</td>
                                    </tr>
                                </tbody>
                                <!-- <tbody>
                                    <tr class="table-class">
                                        <td>PSO1</td>
                                        <td>To prepare graduates who will have a successful professional career in software industry, government, academia, research, and other areas where computer Applications are deployed.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO2</td>
                                        <td>To become a software entrepreneur.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO3</td>
                                        <td>Student will able to know various issues, latest trends in technology development and thereby innovate new ideas and solutions to existing problems.</td>
                                    </tr>
                                    <tr>
                                        <td>PSO4</td>
                                        <td>To prepare broadly educated, ethical and responsible citizens.</td>
                                    </tr>
                                </tbody> -->
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">

            </div>
        </div>
    </div>
</section>
